import { Box, Button, Grid, Typography, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { apiStore } from '../../../api/ApiFactory';
import { IOrderPrint } from '../../../models/OrderManagement';
import TableComponent from './TableComponent';
import BentleyLogo from "../../../_assets/images/bentley-logo.png";
import QrCode from "../../../_assets/images/qrcode.png";
import Specifications from "./Specifications";
import PerspectiveImage from './PerspectiveImage';
const WindowSticker = () => {
  let { orderNum } = useParams();
  const [data, setData] = useState<IOrderPrint>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => { 
    if (orderNum) {
      setLoading(true);
      const result = apiStore.orderManagementApi.getPrintDetails({ orderNum: Number(orderNum) })
      result.then((response) => {
        setData(response);         
        setLoading(false);
      })
    }
  }, []);

  const getPartialAddress = (value1: string, value2: string, useComma: boolean) => {

    let result: string = value1;
    let seperator: string = useComma ? ", " : " ";

    if(value1.length == 0 || value2.length == 0) {
      seperator = "";
    }

    result += (seperator + value2);

    return result;
  }


  const handlePrint = () => {
    window.print();
  }
  const handleCancel = () => {
    window.close();
  }

  if (loading) {
    return <p>Loading....</p>
  }

  return (
    <>
      <Box id="print" className='print-container' >
        {
          data && (
            <>
              <Grid container mb={1} justifyContent="space-between">
                <Grid item md={6} display="flex">
                  <Grid item md={6}>
                    <img style={{ height: "30px" }} src={BentleyLogo} alt="bentley-logo" />
                  </Grid>
                </Grid>
                <Grid item md={6} display="flex" justifyContent="flex-end">
                    <Grid container spacing={2} display="flex" justifyContent="flex-end">
                      <Grid item>
                        <Typography fontWeight={"bold"}>{data.dealerContact.name}</Typography>
                        <Typography>{getPartialAddress(data?.dealerContact.address1, "", false)}</Typography>
                        {data?.dealerContact.address2 && (
                          <Typography>{getPartialAddress(data?.dealerContact.address2, "", false)}</Typography>
                        )}
                        {(data?.dealerContact.city || data?.dealerContact.state) && (
                          <Typography>
                            {getPartialAddress(
                                getPartialAddress(data?.dealerContact.city, data?.dealerContact.state, true), 
                                data?.dealerContact.zipCode, 
                                false
                            )}
                          </Typography>
                        )}
                        <Typography>{data?.dealerContact?.phone}</Typography>
                      </Grid>
                      <Grid item>
                        <img src={QrCode} alt="" style={{ height: "65px" }} />
                      </Grid>
                    </Grid>
                </Grid>
              </Grid>
              <Grid container justifyContent="space-between">
                <Grid item md={6}>
                  <Grid container spacing={4} alignItems="center">
                    <Grid item>
                      <Typography fontWeight="bold" color="#008EBF" className="text-12">{data?.modelName}</Typography>
                    </Grid>
                    <Grid item >
                      <Stack direction="row" spacing={2}>
                        <Typography>Series: {data?.seriesName}</Typography>
                        <Typography>Model Year: {data?.modelYear}</Typography>
                      </Stack>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item>
                  <Typography>HIN Number: {!!data?.hin ? data.hin : "Unknown" }</Typography>
                </Grid>
              </Grid>                          
              <PerspectiveImage data={data?.layeredMedia ?? []} />
              {
                data?.standardEquipment && ( 
                  <Grid mt={1} container className="standard-equipments">
                    <Grid item>
                      <Typography className="table-heading" >Standard Equipment</Typography>
                      <Typography >
                        {
                          data?.standardEquipment
                        }
                      </Typography>
                    </Grid>
                    
                </Grid>
                )
               }  
              <Grid container justifyContent="space-between" alignItems="start" spacing={2}>
                <Grid item xs={8}>
                  <TableComponent data={data} type={"salesPrice"} />
                </Grid>
                <Grid item xs={4} >
                  <Grid container>
                    {
                      data?.colors.length > 0 && (
                        <Grid item xs={12} className="colors-container">
                          <Specifications data={data?.colors} tableHeader="Colors" />
                        </Grid>
                      )
                    }
                    {
                      data?.specifications.length > 0  && (
                        <Grid item xs={12} className="specification-container">
                        <Specifications data={data?.specifications} tableHeader="Specifications" />
                      </Grid>
                      )
                    }
                  </Grid>
                  
                </Grid>
              </Grid>
              <Typography mt={3} className="disc-text ">*Standards and options are subject to change</Typography>
              <Grid container justifyContent="flex-end" spacing={2}>
                <Grid item><Button className="print-btn btn" onClick={handlePrint}>Print</Button></Grid>
              </Grid>
            </>
          )
        }
      </Box>
    </>
  )
}

export default WindowSticker;